// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2JMhh","button":"Chip_button__32mwC","text":"Chip_text__gO_24"};